export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["failed"] = "failed";
    ActionStatus["succeeded"] = "succeeded";
})(ActionStatus || (ActionStatus = {}));
export var AppCollaboratorType;
(function (AppCollaboratorType) {
    AppCollaboratorType["COLLABORATOR"] = "COLLABORATOR";
    AppCollaboratorType["OWNER"] = "OWNER";
})(AppCollaboratorType || (AppCollaboratorType = {}));
export var CustomFieldPrivacyOptions;
(function (CustomFieldPrivacyOptions) {
    CustomFieldPrivacyOptions["ADMIN"] = "ADMIN";
    CustomFieldPrivacyOptions["OWN"] = "OWN";
})(CustomFieldPrivacyOptions || (CustomFieldPrivacyOptions = {}));
export var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["array"] = "array";
    CustomFieldType["boolean"] = "boolean";
    CustomFieldType["date"] = "date";
    CustomFieldType["number"] = "number";
    CustomFieldType["object"] = "object";
    CustomFieldType["relation"] = "relation";
    CustomFieldType["richText"] = "richText";
    CustomFieldType["text"] = "text";
})(CustomFieldType || (CustomFieldType = {}));
export var CustomFieldValidators;
(function (CustomFieldValidators) {
    CustomFieldValidators["allOf"] = "allOf";
    CustomFieldValidators["anyOf"] = "anyOf";
    CustomFieldValidators["enum"] = "enum";
    CustomFieldValidators["exclusiveMaximum"] = "exclusiveMaximum";
    CustomFieldValidators["exclusiveMinimum"] = "exclusiveMinimum";
    CustomFieldValidators["format"] = "format";
    CustomFieldValidators["maxItems"] = "maxItems";
    CustomFieldValidators["maxLength"] = "maxLength";
    CustomFieldValidators["maxProperties"] = "maxProperties";
    CustomFieldValidators["maximum"] = "maximum";
    CustomFieldValidators["minItems"] = "minItems";
    CustomFieldValidators["minLength"] = "minLength";
    CustomFieldValidators["minProperties"] = "minProperties";
    CustomFieldValidators["minimum"] = "minimum";
    CustomFieldValidators["multipleOf"] = "multipleOf";
    CustomFieldValidators["not"] = "not";
    CustomFieldValidators["oneOf"] = "oneOf";
    CustomFieldValidators["pattern"] = "pattern";
    CustomFieldValidators["uniqueItems"] = "uniqueItems";
})(CustomFieldValidators || (CustomFieldValidators = {}));
export var DateTypeOptions;
(function (DateTypeOptions) {
    DateTypeOptions["date"] = "date";
    DateTypeOptions["datetime"] = "datetime";
})(DateTypeOptions || (DateTypeOptions = {}));
export var DefaultDynamicBlockKeys;
(function (DefaultDynamicBlockKeys) {
    DefaultDynamicBlockKeys["settings"] = "settings";
})(DefaultDynamicBlockKeys || (DefaultDynamicBlockKeys = {}));
export var DynamicBlockSize;
(function (DynamicBlockSize) {
    DynamicBlockSize["full"] = "full";
    DynamicBlockSize["lg"] = "lg";
    DynamicBlockSize["md"] = "md";
    DynamicBlockSize["sm"] = "sm";
    DynamicBlockSize["xl"] = "xl";
})(DynamicBlockSize || (DynamicBlockSize = {}));
export var EventNoun;
(function (EventNoun) {
    EventNoun["APP"] = "APP";
    EventNoun["APP_INSTALLATION"] = "APP_INSTALLATION";
    EventNoun["BADGE"] = "BADGE";
    EventNoun["COLLECTION"] = "COLLECTION";
    EventNoun["CUSTOM"] = "CUSTOM";
    EventNoun["EXTRA_PROPERTY"] = "EXTRA_PROPERTY";
    EventNoun["IMPORT_REQUEST"] = "IMPORT_REQUEST";
    EventNoun["MEMBER"] = "MEMBER";
    EventNoun["MEMBER_BADGE"] = "MEMBER_BADGE";
    EventNoun["MEMBER_INVITATION"] = "MEMBER_INVITATION";
    EventNoun["MEMBER_SESSION"] = "MEMBER_SESSION";
    EventNoun["MODERATION"] = "MODERATION";
    EventNoun["NETWORK"] = "NETWORK";
    EventNoun["ORGANIZATION"] = "ORGANIZATION";
    EventNoun["PLAN"] = "PLAN";
    EventNoun["POST"] = "POST";
    EventNoun["POST_TYPE"] = "POST_TYPE";
    EventNoun["REACTION"] = "REACTION";
    EventNoun["ROLE"] = "ROLE";
    EventNoun["SHORTCUT"] = "SHORTCUT";
    EventNoun["SPACE"] = "SPACE";
    EventNoun["SPACE_JOIN_REQUEST"] = "SPACE_JOIN_REQUEST";
    EventNoun["SPACE_MEMBERSHIP"] = "SPACE_MEMBERSHIP";
    EventNoun["SPACE_NETWORK_ROLE"] = "SPACE_NETWORK_ROLE";
    EventNoun["SPACE_POST_TYPE"] = "SPACE_POST_TYPE";
    EventNoun["SPACE_ROLE"] = "SPACE_ROLE";
    EventNoun["SSO"] = "SSO";
    EventNoun["SSO_MEMBERSHIP"] = "SSO_MEMBERSHIP";
    EventNoun["SUBSCRIPTION"] = "SUBSCRIPTION";
    EventNoun["SYNC_EVENT"] = "SYNC_EVENT";
    EventNoun["TAG"] = "TAG";
    EventNoun["TRACKER"] = "TRACKER";
})(EventNoun || (EventNoun = {}));
export var EventVerb;
(function (EventVerb) {
    EventVerb["ACCEPTED"] = "ACCEPTED";
    EventVerb["ADDED"] = "ADDED";
    EventVerb["BANNED"] = "BANNED";
    EventVerb["BLOCKED"] = "BLOCKED";
    EventVerb["CANCELED"] = "CANCELED";
    EventVerb["CLICKED"] = "CLICKED";
    EventVerb["CREATED"] = "CREATED";
    EventVerb["CUSTOM"] = "CUSTOM";
    EventVerb["DELETED"] = "DELETED";
    EventVerb["EXPIRED"] = "EXPIRED";
    EventVerb["FAILED"] = "FAILED";
    EventVerb["FOLLOWED"] = "FOLLOWED";
    EventVerb["HIDDEN"] = "HIDDEN";
    EventVerb["IMPRESSION"] = "IMPRESSION";
    EventVerb["INSTALLED"] = "INSTALLED";
    EventVerb["LOGGED_IN"] = "LOGGED_IN";
    EventVerb["NOT_ASSIGNED"] = "NOT_ASSIGNED";
    EventVerb["PERMITTED"] = "PERMITTED";
    EventVerb["PING"] = "PING";
    EventVerb["PINGED"] = "PINGED";
    EventVerb["PINNED"] = "PINNED";
    EventVerb["PUBLISHED"] = "PUBLISHED";
    EventVerb["REJECTED"] = "REJECTED";
    EventVerb["REMOVED"] = "REMOVED";
    EventVerb["REVOKED"] = "REVOKED";
    EventVerb["SUSPENDED"] = "SUSPENDED";
    EventVerb["UNBLOCKED"] = "UNBLOCKED";
    EventVerb["UNFOLLOWED"] = "UNFOLLOWED";
    EventVerb["UNHIDDEN"] = "UNHIDDEN";
    EventVerb["UNINSTALLED"] = "UNINSTALLED";
    EventVerb["UNPINNED"] = "UNPINNED";
    EventVerb["UNPUBLISHED"] = "UNPUBLISHED";
    EventVerb["UNSUSPENDED"] = "UNSUSPENDED";
    EventVerb["UNUSED"] = "UNUSED";
    EventVerb["UNVERIFIED"] = "UNVERIFIED";
    EventVerb["UPDATED"] = "UPDATED";
    EventVerb["USED"] = "USED";
    EventVerb["VERIFIED"] = "VERIFIED";
    EventVerb["VIEWED"] = "VIEWED";
})(EventVerb || (EventVerb = {}));
export var NetworkMembership;
(function (NetworkMembership) {
    NetworkMembership["inviteOnly"] = "inviteOnly";
    NetworkMembership["open"] = "open";
})(NetworkMembership || (NetworkMembership = {}));
export var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus["archived"] = "archived";
    NetworkStatus["published"] = "published";
    NetworkStatus["unpublished"] = "unpublished";
})(NetworkStatus || (NetworkStatus = {}));
export var NetworkVisibility;
(function (NetworkVisibility) {
    NetworkVisibility["private"] = "private";
    NetworkVisibility["public"] = "public";
})(NetworkVisibility || (NetworkVisibility = {}));
export var NumberTypeOptions;
(function (NumberTypeOptions) {
    NumberTypeOptions["integer"] = "integer";
    NumberTypeOptions["number"] = "number";
})(NumberTypeOptions || (NumberTypeOptions = {}));
export var PermissionContext;
(function (PermissionContext) {
    PermissionContext["MEMBER"] = "MEMBER";
    PermissionContext["NETWORK"] = "NETWORK";
    PermissionContext["POST"] = "POST";
    PermissionContext["SPACE"] = "SPACE";
})(PermissionContext || (PermissionContext = {}));
export var PlanName;
(function (PlanName) {
    PlanName["Advanced"] = "Advanced";
    PlanName["Basic"] = "Basic";
    PlanName["Enterprise"] = "Enterprise";
    PlanName["Plus"] = "Plus";
    PlanName["PlusLegacy"] = "PlusLegacy";
    PlanName["Premium"] = "Premium";
    PlanName["PremiumLegacy"] = "PremiumLegacy";
    PlanName["basic"] = "basic";
    PlanName["enterprise"] = "enterprise";
    PlanName["plus"] = "plus";
    PlanName["premium"] = "premium";
})(PlanName || (PlanName = {}));
export var PostTypeContext;
(function (PostTypeContext) {
    PostTypeContext["post"] = "post";
    PostTypeContext["reply"] = "reply";
})(PostTypeContext || (PostTypeContext = {}));
export var PrimaryScopes;
(function (PrimaryScopes) {
    PrimaryScopes["CreateContent"] = "CreateContent";
    PrimaryScopes["DeleteAuthMember"] = "DeleteAuthMember";
    PrimaryScopes["DeleteContent"] = "DeleteContent";
    PrimaryScopes["DeleteMember"] = "DeleteMember";
    PrimaryScopes["DeleteNetwork"] = "DeleteNetwork";
    PrimaryScopes["FindAuthMember"] = "FindAuthMember";
    PrimaryScopes["FindContent"] = "FindContent";
    PrimaryScopes["FindNetwork"] = "FindNetwork";
    PrimaryScopes["FullAccess"] = "FullAccess";
    PrimaryScopes["InviteMember"] = "InviteMember";
    PrimaryScopes["JoinNetwork"] = "JoinNetwork";
    PrimaryScopes["UpdateAuthMember"] = "UpdateAuthMember";
    PrimaryScopes["UpdateBilling"] = "UpdateBilling";
    PrimaryScopes["UpdateContent"] = "UpdateContent";
    PrimaryScopes["UpdateMember"] = "UpdateMember";
    PrimaryScopes["UpdateModeration"] = "UpdateModeration";
    PrimaryScopes["UpdateNetwork"] = "UpdateNetwork";
    PrimaryScopes["UpdateReport"] = "UpdateReport";
    PrimaryScopes["ViewAuthMember"] = "ViewAuthMember";
    PrimaryScopes["ViewContent"] = "ViewContent";
    PrimaryScopes["ViewMember"] = "ViewMember";
    PrimaryScopes["ViewNetwork"] = "ViewNetwork";
    PrimaryScopes["ViewReport"] = "ViewReport";
})(PrimaryScopes || (PrimaryScopes = {}));
export var ReactionType;
(function (ReactionType) {
    ReactionType["EMOJI_BASE"] = "EMOJI_BASE";
    ReactionType["LIKE_BASE"] = "LIKE_BASE";
    ReactionType["VOTE_BASE"] = "VOTE_BASE";
})(ReactionType || (ReactionType = {}));
export var RelationTypeOptions;
(function (RelationTypeOptions) {
    RelationTypeOptions["Media"] = "Media";
    RelationTypeOptions["Member"] = "Member";
    RelationTypeOptions["Post"] = "Post";
    RelationTypeOptions["Space"] = "Space";
    RelationTypeOptions["Tag"] = "Tag";
})(RelationTypeOptions || (RelationTypeOptions = {}));
export var RichTextTypeOptions;
(function (RichTextTypeOptions) {
    RichTextTypeOptions["html"] = "html";
    RichTextTypeOptions["markup"] = "markup";
})(RichTextTypeOptions || (RichTextTypeOptions = {}));
export var StoreItemStanding;
(function (StoreItemStanding) {
    StoreItemStanding["OFFICIAL"] = "OFFICIAL";
    StoreItemStanding["REGULAR"] = "REGULAR";
    StoreItemStanding["VERIFIED"] = "VERIFIED";
})(StoreItemStanding || (StoreItemStanding = {}));
export var StoreItemStatus;
(function (StoreItemStatus) {
    StoreItemStatus["DELETED"] = "DELETED";
    StoreItemStatus["PRIVATE"] = "PRIVATE";
    StoreItemStatus["PUBLIC"] = "PUBLIC";
})(StoreItemStatus || (StoreItemStatus = {}));
export var TemplateEntityType;
(function (TemplateEntityType) {
    TemplateEntityType["Post"] = "Post";
    TemplateEntityType["PostType"] = "PostType";
    TemplateEntityType["Space"] = "Space";
    TemplateEntityType["SpacePostType"] = "SpacePostType";
    TemplateEntityType["Tag"] = "Tag";
})(TemplateEntityType || (TemplateEntityType = {}));
export var TextTypeOptions;
(function (TextTypeOptions) {
    TextTypeOptions["fullText"] = "fullText";
    TextTypeOptions["shortText"] = "shortText";
})(TextTypeOptions || (TextTypeOptions = {}));
const result = {
    possibleTypes: {
        Media: ['Emoji', 'File', 'Image'],
    },
};
export default result;
//# sourceMappingURL=tribe-global-graphql.generated.js.map